import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { ClipboardList, ArrowLeft } from 'lucide-react';
import { useLanguage } from '@/contexts/LanguageContext';
import { ROUTES } from '@/lib/routes';
import type { CategoryKey } from '@/lib/navigation';

const ORDER_CATEGORY: CategoryKey = 'order';

const OrderOverview: React.FC = () => {
  const navigate = useNavigate();
  const { language } = useLanguage();

  return (
    <div className="min-h-screen bg-background p-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-4 mb-6">
          <Button
            variant="outline"
            onClick={() => {
              localStorage.setItem('selectedCategory', ORDER_CATEGORY);
              navigate(ROUTES.dashboard.root);
            }}
            className="bg-card/50 border-border text-muted-foreground hover:bg-accent/50"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            {language === 'zh' ? '返回主控台' : 'Back to Dashboard'}
          </Button>
          <div className="flex items-center gap-2">
            <ClipboardList className="w-6 h-6 text-purple-400" />
            <h1 className="text-2xl font-bold bg-gradient-to-r from-purple-400 to-cyan-400 bg-clip-text text-transparent">{language === 'zh' ? '訂單總覽' : 'Order Overview'}</h1>
          </div>
        </div>

        <Card className="bg-card/80 border-border">
          <CardHeader>
            <CardTitle className="text-foreground">{language === 'zh' ? '即將推出' : 'Coming Soon'}</CardTitle>
          </CardHeader>
          <CardContent className="text-muted-foreground">
            {language === 'zh' ? '此頁面為骨架，功能將於銷售導入完成後逐步開放。' : 'This is a placeholder page. Features will arrive after sales import implementation.'}
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default OrderOverview;


